import bindAllMethods from '../../utils/bindAllMethods';
import { InternalService } from '../../core/services';
import * as T from './types';
import { getMap } from './utils';
import IEventService from './IEventService';
import EventNames from '../../config/eventNames';

export default abstract class BaseEventService
  extends InternalService
  implements IEventService
{
  public _listenerHandlerMap: T.RemoveListenersMapType;
  public eventNames;

  constructor() {
    super();
    this._listenerHandlerMap = new Map();
    this.eventNames = EventNames;
    bindAllMethods(this);
  }

  abstract subscribe(
    eventName: string,
    action: T.EventServiceCallBackType,
    options?: T.EventServiceSubscribeOptionsType
  ): Promise<T.ListenerHandlerType>;

  abstract publish(
    eventName: string,
    eventData: T.EventServiceValueType['eventData']
  ): Promise<void>;

  addEventListener(name: string, action: T.EventCallBackType): void {
    const actionMap = getMap(name, this._listenerHandlerMap);
    const listenerHandler = this.subscribe(name, action);

    actionMap.set(action, listenerHandler);
  }

  removeEventListener(name: string, action: T.EventCallBackType): void {
    const actionMap = getMap(name, this._listenerHandlerMap);
    const listenerHandlerPromise = actionMap.get(action);

    actionMap.delete(action);

    listenerHandlerPromise.then((listenerHandler) =>
      listenerHandler.unsubscribe()
    );
  }
}
